import { FieldValues, Path, PathValue, useFormContext } from 'react-hook-form';

import { Select, Skeleton } from '@/components';

import { R } from '@/caregiverSpace/resources/Texts.resx';

import { getPhysioOutcomeOptions } from '../lib/physioOutcomeOptions';

type PhysioOutcomeSelectProps<TFieldValues extends FieldValues> = {
    name: Path<TFieldValues>;
    isVideo: boolean;
    isLoading?: boolean;
};

export const PhysioOutcomeSelect = <TFieldValues extends FieldValues>({
    name,
    isVideo,
    isLoading = false,
}: PhysioOutcomeSelectProps<TFieldValues>) => {
    const { register, setValue } = useFormContext<TFieldValues>();

    if (isLoading) {
        return <Skeleton className="h-9" />;
    }

    const options = getPhysioOutcomeOptions(isVideo);

    return (
        <Select
            {...register(name, {
                required: R.Required,
            })}
            onChange={(e) => {
                const value = Number(e.target.value);
                setValue(name, value as PathValue<TFieldValues, typeof name>, {
                    shouldDirty: true,
                    shouldValidate: true,
                });
            }}
            options={options}
            prompt={R.Outcome}
        />
    );
};
